import * as React from "react";
import moment from "moment";
import upperFirst from "lodash/upperFirst";
import { fromFormStateValue as hourFromFormValue } from "report/common/MinuteOfHourInput";
import { FREQUENCY_OPTIONS } from "report/report-configuration-page/SchedulingFrequencyForm";
import toUTCFrequencyTime from "report/report-configuration-page/toUTCFrequencyTime";
const PLACEHOLDER = /* @__PURE__ */ React.createElement(React.Fragment, null, "No options selected.");
const TimeInfo = ({ time, timezone }) => {
  if (!time) {
    return /* @__PURE__ */ React.createElement("i", null, "Time not configured");
  }
  const utcHourAndMinute = toUTCFrequencyTime(time, timezone);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, time, " ", timezone != null ? timezone : "UTC", " timezone (", utcHourAndMinute, " UTC)");
};
const FrequencySummary = ({ frequency, frequencyConfiguration }) => {
  if (!frequency || !frequencyConfiguration) {
    return PLACEHOLDER;
  }
  switch (frequency) {
    case FREQUENCY_OPTIONS.HOURLY.value:
      if (frequencyConfiguration.time) {
        return /* @__PURE__ */ React.createElement(React.Fragment, null, "Hourly on minute ", hourFromFormValue(frequencyConfiguration.time), " of every hour");
      }
      break;
    case FREQUENCY_OPTIONS.DAILY.value:
      if (frequencyConfiguration.time) {
        return /* @__PURE__ */ React.createElement(React.Fragment, null, "Daily at ", /* @__PURE__ */ React.createElement(TimeInfo, { time: frequencyConfiguration.time, timezone: frequencyConfiguration.timezone }), ".");
      }
      break;
    case FREQUENCY_OPTIONS.WEEKLY.value:
      if ("day_of_week" in frequencyConfiguration && frequencyConfiguration.day_of_week && frequencyConfiguration.time) {
        return /* @__PURE__ */ React.createElement(React.Fragment, null, "Weekly every ", upperFirst(frequencyConfiguration.day_of_week), " at", " ", /* @__PURE__ */ React.createElement(TimeInfo, { time: frequencyConfiguration.time, timezone: frequencyConfiguration.timezone }), ".");
      }
      break;
    case FREQUENCY_OPTIONS.MONTHLY.value:
      if ("day_of_month" in frequencyConfiguration && frequencyConfiguration.day_of_month && frequencyConfiguration.time) {
        const ordinalDay = moment.localeData().ordinal(upperFirst(frequencyConfiguration.day_of_month));
        return /* @__PURE__ */ React.createElement(React.Fragment, null, "Monthly the ", ordinalDay, " day at", " ", /* @__PURE__ */ React.createElement(TimeInfo, { time: frequencyConfiguration.time, timezone: frequencyConfiguration.timezone }), ".");
      }
      break;
    default:
      break;
  }
  return PLACEHOLDER;
};
export default FrequencySummary;
